import type * as React from "react";
import { cn } from "./cn";

// The mock's .input: 36 px high, field border, 7 px radius.
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-9 w-full min-w-0 rounded-sm border border-field-border bg-surface px-2.5 text-base text-ink transition-colors placeholder:text-ink-3 hover:border-ink-3 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-crit file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
